<section class="article">
  <div class="article__inner row pad">
    @if(article) {
    <div class="breadcrumbs">
      <a routerLink="/press" class="breadcrumbs__item">Press</a>
      <img
        class="breadcrumbs__separator"
        src="/arrow.svg"
        alt="Breadcrumb separator"
      />
      <div class="breadcrumbs__item">{{ article.breadcrumb }}</div>
    </div>
    <div class="article__item">
      <div class="article__date text-muted">{{ article.date }}</div>
      <h1
        class="article__title"
        [class.article__title--with-subtitle]="article.subtitle"
      >
        {{ article.title }}
      </h1>
      @if (article.subtitle) {
      <p class="article__subtitle">{{ article.subtitle }}</p>
      }
      <div class="article__body" [innerHTML]="article.bodyHtml"></div>
    </div>
    } @else {
    <div class="article__item not-found">
      <h1 class="article__title">Article not found</h1>
      <p>We couldn't find that article.</p>
    </div>
    }
  </div>
</section>
